import { priceMapper } from "./price";

function getVariantSize({ displaySizeText, brandSize }) {
  if (displaySizeText) {
    return displaySizeText;
  }

  return brandSize;
}

export const variantMapper = (variant, shouldMapPrice) => {
  const {
    isInStock,
    hasIngredients,
    sizeId,
    colour,
    colourWayId,
    isPrimary,
    sizeOrder,
    seller,
    source,
    ean,
    sku,
    brandSize,
    showShippedByMessage,
  } = variant;

  const size = getVariantSize(variant);
  const validBrandSize = brandSize || size;

  return {
    variantId: variant.id,
    size,
    brandSize: validBrandSize,
    price: shouldMapPrice ? priceMapper(variant) : undefined,
    isLowInStock: shouldMapPrice ? variant.isLowInStock : undefined,
    isInStock,
    hasIngredients,
    sizeId,
    colour,
    colourWayId,
    isPrimary,
    sizeOrder,
    seller,
    source,
    ean,
    sku,
    showShippedByMessage,
  };
};
